import types from './types'
import firebase from 'firebase/app'
import 'firebase/firestore'
import globaltypes from '../globaltypes'
import { $t } from '../../plugins/VueI18n'
import { cloneDeep, includes } from 'lodash'
import OrderService from '../../services/OrderService'

export default {
  [types.actions.fill]: context => {
    const userID = context.getters[globaltypes.user.getters.currentUser].id
    firebase.firestore().collection('shoppingcartitems')
      .where('userID', '==', userID)
      .onSnapshot(function (snapshot) {
        snapshot.docChanges().forEach(function (change) {
          var data = change.doc.data()
          data.key = change.doc.id
          // data.productIDs = data.productIDs || { nl: data.productID, fr: data.productID }
          // data.cropIDs = data.cropIDs || { nl: data.cropID, fr: data.cropID }
          // delete data.cropID
          // delete data.productID
          delete data.cropIDs
          delete data.productIDs
          if (change.type === 'added') {
            context.commit(types.mutations.add, data)
          }
          if (change.type === 'modified') {
            context.commit(types.mutations.edit, data)
          }
          if (change.type === 'removed') {
            context.commit(types.mutations.delete, data)
          }
        })
        context.commit(globaltypes.ui.mutations.setDataLoaded, { tab: 'wishlist', val: true })
      })
  },
  [types.actions.addItemToCart]: async (context, payload) => {
    const cart = context.getters[types.getters.shoppingcartitems]
    const userID = context.getters[globaltypes.user.getters.currentUser].id
    await context.dispatch(globaltypes.products.actions.load, payload.productID)
    const product = context.getters[globaltypes.products.getters.product](payload.productID)
    const productName = product ? product.name : 'product'

    var productline = {
      userID,
      quantity: 1,
      productID: payload.productID,
      cropID: payload.cropID,
      variationID: payload.variationID
    }

    var lineItem = cart.find(x => x.productID === payload.productID && x.cropID === payload.cropID)
    if (lineItem) {
      productline.quantity = parseInt(lineItem.quantity) + 1
      firebase.firestore().collection('shoppingcartitems').doc(lineItem.key).set(productline).then(x => {
        context.dispatch(globaltypes.main.actions.setInformation, $t('wishlist.product_added'))
      })
    } else {
      firebase.firestore().collection('shoppingcartitems').add(productline).then(x => {
        context.dispatch(globaltypes.main.actions.setInformation, $t('wishlist.product_added'))
      })
    }
  },
  [types.actions.deleteProduct]: (context, productlineID) => {
    firebase.firestore().collection('shoppingcartitems').doc(productlineID).delete()
  },
  [types.actions.updateLine]: (context, line) => {
    var key = line.key
    line = cloneDeep(line)
    delete line.key
    firebase.firestore().collection('shoppingcartitems').doc(key).set(line)
  },
  [types.actions.placeOrder]: (context, productIDs) => {
    firebase.auth().currentUser.getIdToken(false).then(token => {
      context.commit(types.mutations.syncing, true)
      const orderlines = context.getters[types.getters.shoppingcartitems]
      const selectedOrderlines = orderlines.filter(line => includes(productIDs, line.productID))
      var linesToOrder = []
      for (var line of selectedOrderlines) {
        var orderline = linesToOrder.find(x => x.productID === line.productID)
        if (orderline) {
          orderline.quantity += line.quantity
        } else {
          linesToOrder.push({
            productID: (parseInt(line.variationID) || parseInt(line.productID)),
            quantity: parseInt(line.quantity),
            variationID: 0
          })
        }
      }
      OrderService.addToCart(token, linesToOrder).then(x => {
        context.commit(types.mutations.syncing, false)
        context.dispatch(types.actions.clearWishlist, productIDs)
      })
    })
  },
  [types.actions.openCart]: (context) => {
    firebase.auth().currentUser.getIdToken(false).then(token => {
      OrderService.openCart(token)
    })
  },
  [types.actions.clearWishlist]: (context, productIDs) => {
    var allTranslationsProductIDs = context.rootGetters[globaltypes.i18n.getters.allTranslationsPostIDs](productIDs)
    const toDelete = context.state.shoppingcartitems
      .filter(x => includes(allTranslationsProductIDs, x.productID))
      .map(x => x.key)

    var batch = firebase.firestore().batch()
    toDelete.forEach(key => {
      batch.delete(firebase.firestore().collection('shoppingcartitems').doc(key))
    })
    batch.commit()
  }
}
